import { render } from "./PagingCom.vue?vue&type=template&id=5827d3ff"
import script from "./PagingCom.vue?vue&type=script&lang=js"
export * from "./PagingCom.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__